import { Directive, HostListener, Input, OnInit, Renderer2 } from "@angular/core";
import { DomController } from "@ionic/angular";
import { GeneralService } from 'src/app/services/general/general.service';

@Directive({
  selector: '[appHideHeader]'
})
export class HideHeaderDirective implements OnInit {

  @Input('appHideHeader') toolbar: any | undefined;
  private toolbarHeight = 96;
  private startScrollTop: number | undefined;
  private previousScrollTop: number = 0;
  private previousScrollDirection: 'up' | 'down' = 'down';
  private currentScrollDirection: 'up' | 'down' = 'down';
  private scrollTimeout;
  private readonly animationUpGap = 48;
  private readonly animationDownGap = 96;
  private readonly animationDownTransitionDelay = '0.2s';
  private readonly tabHeight = this.generalService.isApp ? 52 : 0;

  constructor(private renderer: Renderer2, private domCtrl: DomController, private generalService: GeneralService) {

  }

  ngOnInit(): void {
    this.domCtrl.read(() => {
      if (this.toolbar === undefined) {
        return;
      }
      this.toolbar = this.toolbar.el;
      this.toolbarHeight = this.toolbar.clientHeight === 0 ? this.toolbarHeight : this.toolbar.clientHeight;
    });
  }

  @HostListener('ionScroll', ['$event']) onContentScroll($event) {
    let { scrollTop } = $event.detail;
    const children: HTMLElement[] = $event.target.childNodes ?? [];
    let targetElem: HTMLElement | undefined;
    children.forEach((child) => {
      child.classList.forEach((className) => {
        if (!className.includes('refresher')) {
          targetElem = child;
        }
      })
    })
    if (targetElem === undefined) {
      return;
    }
    const maxScrollTop = targetElem.scrollHeight - $event.target.scrollHeight - this.tabHeight;
    scrollTop = scrollTop < 0 ? Math.max(scrollTop, 0) : Math.min(scrollTop, maxScrollTop);
    if (isNaN(scrollTop)) {
      return;
    }
    this.currentScrollDirection = (this.previousScrollTop - scrollTop) < 0 ? 'down' : 'up';
    // startScrollTop 값이 없거나 반대방향으로 스크롤할 경우
    if (this.startScrollTop === undefined || (this.previousScrollDirection !== this.currentScrollDirection)) {
      this.startScrollTop = scrollTop;
    }
    // 제일 꼭대기에 도달하거나 gap보다 크게 스크롤할 경우 animate
    if (scrollTop === 0 || this.isOverScrollGap(this.startScrollTop!, scrollTop, this.currentScrollDirection)) {
      this.domCtrl.write(() => {
        if (this.toolbar === undefined) {
          return;
        }
        this.renderer.setStyle(this.toolbar, 'transition', 'all 0.15s ease-in');
        if (this.currentScrollDirection === 'down') {
          this.renderer.setStyle(this.toolbar, 'transition-delay', this.animationDownTransitionDelay);
        }
        this.renderer.setStyle(this.toolbar, 'top', `${(this.currentScrollDirection === 'down' && scrollTop > 0) ? -this.toolbarHeight : 0}px`);
      })
    }

    // 모든 연산 끝난 후 현재값으로 previous값 초기화
    this.previousScrollTop = scrollTop;
    this.previousScrollDirection = this.currentScrollDirection;

    // scroll 비교값 초기화 debouncing
    if (this.scrollTimeout !== undefined) {
      clearTimeout(this.scrollTimeout);
    }
    this.scrollTimeout = setTimeout(() => {
      this.startScrollTop = undefined;
      clearTimeout(this.scrollTimeout);
      this.scrollTimeout = undefined;
    }, 100);
  }

  private isOverScrollGap(startScrollTop: number, currentScrollTop: number, scrollDirection: 'up' | 'down'): boolean {
    const diff = Math.abs(startScrollTop - currentScrollTop);
    const gap = (this.currentScrollDirection === 'down' ? this.animationDownGap : this.animationUpGap);
    return diff >= gap;
  }
}